import { RestrictedPage } from 'routes/CrudRoute';

import { SubsActivateInquiry, SubsExtendInquiry, SubsExtendConfirm } from './SubsExtend';
import { SubsEditInquiry, SubsEditConfirm } from './SubsEdit';
import { SubsShopRevoke } from './SubsShopRevoke';
import { SubsList } from './SubsList';

import { SubsOrderList } from './SubsOrderList';
import { SubsOrderPaymentShow } from './SubsOrderPayment';
import { FreeTrialList } from './FreeTrialList';
import { FreeTrialEdit } from './FreeTrialEdit';

import { SubsActivateList } from './SubsActivateList';

import * as urls from './urls';

const SubsActivateResourceName = "Subscription Activate";
const SubsResourceName = "Subscription";
const OrderResourceName = "Subscription Order";
const PaymentResourceName = "Subscription Order Payment";
const FreeTrialResourceName = "Free Trial";
const FreeTrialExtendResourceName = "Free Trial Extend";


const SubsResources = [
  {
    "name": SubsActivateResourceName,
    "frontendPath": urls.subsActivateFrontPath,
    "backendPath": urls.subsActivateBackendPath,
    "list": SubsActivateList,
    "showInSideMenu": true,
  },
  {
    "name": SubsResourceName,
    "frontendPath": urls.subsListFrontPath,
    "backendPath": urls.subsListBackPath,
    "list": SubsList,
    "showInSideMenu": true,
  },
  {
    "name": OrderResourceName,
    "frontendPath": urls.orderListFrontPath,
    "backendPath": urls.orderListBackPath,
    "list": SubsOrderList,
    "showInSideMenu": true,
  },
  {
    "name": PaymentResourceName,
    "frontendPath": urls.paymentListFrontPath,
    "backendPath": urls.paymentListBackPath,
    "showInSideMenu": false,
  },
  {
    "name": FreeTrialExtendResourceName,
    "frontendPath": urls.freeTrialEditFrontPath,
    "backendPath": urls.freeTrialDetailBackPath,
    "showInSideMenu": false,
  },
  {
    "name": FreeTrialResourceName,
    "frontendPath": urls.freeTrialListFrontPath,
    "backendPath": urls.freeTrialListBackPath,
    "editBackendPath": urls.freeTrialDetailBackPath,
    "detailBackendPath": urls.freeTrialDetailBackPath,
    "list": FreeTrialList,
    "showInSideMenu": true,
  },
];


const SubsCustomRoutes = [
  {
    "name": "Subscription Extend",
    "frontendPath": urls.subsExtendInquiryFrontPath,
    "backendPath": urls.subsExtendInquiryBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsExtendInquiry, 'extend', {
      'resource': SubsResourceName,
      'backendPath': urls.subsExtendInquiryBackPath,
      'updateDataOnMount': true,
      'redirectPath': urls.subsExtendConfirmFrontPath,
    })
  },
  {
    "name": "Subscription Extend Confirm",
    "frontendPath": urls.subsExtendConfirmFrontPath,
    "backendPath": urls.subsExtendConfirmBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsExtendConfirm, 'extend confirm', {
      'resource': SubsResourceName,
      'backendPath': urls.subsExtendConfirmBackPath,
      'updateDataOnMount': false,
      'redirectPath': urls.subsListFrontPath,
    })
  },
  {
    "name": "Subscription Increase Branch",
    "frontendPath": urls.subsEditInquiryFrontPath,
    "backendPath": urls.subsEditInquiryBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsEditInquiry, 'increase branch', {
      'resource': SubsResourceName,
      'backendPath': urls.subsEditInquiryBackPath,
      'updateDataOnMount': true,
      'redirectPath': urls.subsEditConfirmFrontPath,
    })
  },
  {
    "name": "Subscription Increase Branch Confirm",
    "frontendPath": urls.subsEditConfirmFrontPath,
    "backendPath": urls.subsEditConfirmBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsEditConfirm, 'increase branch confirm', {
      'resource': SubsResourceName,
      'backendPath': urls.subsEditConfirmBackPath,
      'updateDataOnMount': false,
      'redirectPath': urls.subsListFrontPath,
    })
  },
  {
    "name": "Subscription Revoke Shop",
    "frontendPath": urls.subsShopRevokeFrontPath,
    "backendPath": urls.subsShopRevokeBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsShopRevoke, 'revoke shop', {
      'resource': SubsResourceName,
      'backendPath': urls.subsShopRevokeBackPath,
      'updateDataOnMount': true,
      'redirectPath': urls.subsListFrontPath,
    })
  },
  {
    "name": "Subscription Order Payment Detail",
    "frontendPath": urls.paymentDetailFrontPath,
    "backendPath": urls.paymentDetailBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsOrderPaymentShow, 'payment', {
      'resource': PaymentResourceName,
      'backendPath': urls.paymentDetailBackPath,
      "detailBackendPath": urls.paymentDetailBackPath,
    })
  },
  {
    "name": "Subscription Activate",
    "frontendPath": urls.subsActivateInquiryFrontPath,
    "backendPath": urls.subsExtendInquiryBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsActivateInquiry, 'activate', {
      'resource': SubsActivateResourceName,
      'backendPath': urls.subsExtendInquiryBackPath,
      'updateDataOnMount': false,
      'redirectPath': urls.subsActivateConfirmFrontPath,
    })
  },
  {
    "name": "Subscription Activate Confirm",
    "frontendPath": urls.subsActivateConfirmFrontPath,
    "backendPath": urls.subsExtendConfirmBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(SubsExtendConfirm, 'activate confirm', {
      'resource': SubsActivateResourceName,
      'backendPath': urls.subsExtendConfirmBackPath,
      'updateDataOnMount': false,
      'redirectPath': urls.subsActivateFrontPath,
    })
  },
  {
    "name": "Free Trial Extend",
    "frontendPath": urls.freeTrialEditFrontPath,
    "backendPath": urls.freeTrialDetailBackPath,
    "editBackendPath": urls.freeTrialDetailBackPath,
    "detailBackendPath": urls.freeTrialDetailBackPath,
    "showInSideMenu": false,
    "render": RestrictedPage(FreeTrialEdit, 'extend', {
      'resource': FreeTrialExtendResourceName,
      'backendPath': urls.freeTrialEditBackPath,
      "editBackendPath": urls.freeTrialDetailBackPath,
      "detailBackendPath": urls.freeTrialDetailBackPath,
      'updateDataOnMount': true,
      'redirectPath': urls.freeTrialListFrontPath,
    })
  },
];



export { 
  SubsResources,
  SubsCustomRoutes,
}


// WEBPACK FOOTER //
// ./src/routes/subscription/resources.js